// @ts-nocheck
import Vue from 'vue'
import StarRating from 'vue-star-rating'

Vue.component('SignIn', () => import('./SignIn'))
Vue.component('SignedInOnly', () => import('./SignedInOnly'))
Vue.component('SignedOutOnly', () => import('./SignedOutOnly'))
Vue.component('SignUp', () => import('./SignUp'))
Vue.component('SignOut', () => import('./SignOut'))
Vue.component('ItemAddToCart', () => import('./ItemAddToCart'))
Vue.component('ItemAddToCartRegular', () => import('./ItemAddToCartRegular'))
Vue.component('ItemAddToCartTrial', () => import('./ItemAddToCartTrial'))
Vue.component('ItemAddToCartButton', () => import('./ItemAddToCartButton'))
Vue.component('ItemAddToCartImage', () => import('./ItemAddToCartImage'))
Vue.component('ItemAddToTrialCartButton', () => import('./ItemAddToTrialCartButton'))
Vue.component('ItemAddToTrialCartImage', () => import('./ItemAddToTrialCartImage'))
Vue.component('ItemAddToCartRegularButton', () => import('./ItemAddToCartRegularButton'))
Vue.component('ItemAddToCartRegularImage', () => import('./ItemAddToCartRegularImage'))
Vue.component('CartDisplay', () => import('./CartDisplay'))
Vue.component('CartCouponInput', () => import('./CartCouponInput'))
Vue.component('CartCouponSelect', () => import('./CartCouponSelect'))
Vue.component('CartPriceDisplay', () => import('./CartPriceDisplay'))
Vue.component('CartItemListItem', () => import('./CartItemListItem'))
Vue.component('CartAddressInput', () => import('./CartAddressInput'))
Vue.component('CartPaymentInput', () => import('./CartPaymentInput'))
Vue.component('CartPaymentCreditCardAddNew', () => import('./CartPaymentCreditCardAddNew'))
Vue.component('CartPaymentCreditCardSelect', () => import('./CartPaymentCreditCardSelect'))
Vue.component('GMOPGCreditCardAddNew', () => import('./GMOPGCreditCardAddNew'))
Vue.component('CartOrderCommit', () => import('./CartOrderCommit'))
Vue.component('CartOrderCommitListItem', () => import('./CartOrderCommitListItem'))
Vue.component('CartOrderCompleted', () => import('./CartOrderCompleted'))
Vue.component('CartEditDeliveryUnitOptions', () => import('./CartEditDeliveryUnitOptions'))
Vue.component('DeliveryAddressConfirm', () => import('./DeliveryAddressConfirm'))
Vue.component('DeliveryAddressForm', () => import('./DeliveryAddressForm'))
Vue.component('DeliveryAddressListItem', () => import('./DeliveryAddressListItem'))
Vue.component('Mypage', () => import('./Mypage'))
Vue.component('MypageTop', () => import('./MypageTop'))
Vue.component('UserChangeProfile', () => import('./UserChangeProfile'))
Vue.component('UserDeliveryAddresses', () => import('./UserDeliveryAddresses'))
Vue.component('UserDeliveryAddressesAdd', () => import('./UserDeliveryAddressesAdd'))
Vue.component('UserOrderHistories', () => import('./UserOrderHistories'))
Vue.component('UserRegularOrderHistories', () => import('./UserRegularOrderHistories'))
Vue.component('UserResetPassword', () => import('./UserResetPassword'))
Vue.component('UserCreditCards', () => import('./UserCreditCards'))
Vue.component('UserCreditCardsAdd', () => import('./UserCreditCardsAdd'))
Vue.component('UserCreditCardsDelete', () => import('./UserCreditCardsDelete'))
Vue.component('UseContinuousBilling', () => import('./UseContinuousBilling'))
Vue.component('UserCouponList', () => import('./UserCouponList'))
Vue.component('UserChangePassword', () => import('./UserChangePassword'))
Vue.component('Pagination', () => import('./Pagination'))
Vue.component('PaginationHd', () => import('./PaginationHD'))
Vue.component('SiteHeader', () => import('./SiteHeader'))
Vue.component('SiteFooter', () => import('./SiteFooter'))
Vue.component('SocialPlusAuthentication', () => import('./SocialPlusAuthentication'))
Vue.component('TrialCart', () => import('./TrialCart'))
Vue.component('TrialCartDisplay', () => import('./TrialCartDisplay'))
Vue.component('TrialCartOrderCommit', () => import('./TrialCartOrderCommit'))
Vue.component('TrialCartOrderComplete', () => import('./TrialCartOrderComplete'))
Vue.component('ItemBrowserHistories', () => import('./ItemBrowserHistories'))
Vue.component('RegularCourseInformation', () => import('./RegularCourseInformation'))
Vue.component('ValidationMessage', () => import('./ValidationMessage'))
Vue.component('SignUpForm', () => import('./SignUpForm'))
Vue.component('SignUpConfirm', () => import('./SignUpConfirm'))
Vue.component('SignUpComplete', () => import('./SignUpComplete'))
Vue.component('UserResetPasswordSignup', () => import('./UserResetPasswordSignup'))
Vue.component('UserRegularOrder', () => import('./UserRegularOrder'))
Vue.component('UserDeliveryAddressesEdit', () => import('./UserDeliveryAddressesEdit'))
Vue.component('UserDeliveryAddressesListItem', () => import('./UserDeliveryAddressesListItem'))
Vue.component('HeaderAccount', () => import('./HeaderAccount'))
Vue.component('HeaderNaviAccount', () => import('./HeaderNaviAccount'))
Vue.component('InquiryForm', () => import('./InquiryForm'))
Vue.component('UserOrderHistoriesMypage', () => import('./UserOrderHistoriesMypage'))
Vue.component('EcUsageProcedures', () => import('./EcUsageProcedures'))
Vue.component('EcUsageProceduresSignUp', () => import('./EcUsageProceduresSignUp'))
Vue.component('EcUsageProceduresConfirm', () => import('./EcUsageProceduresConfirm'))
Vue.component('EcUsageProceduresComplete', () => import('./EcUsageProceduresComplete'))


// Framework Items
Vue.component('ModelForm', () => import('@shared/nuxt/components/modelForm'))
Vue.component('AxE2ModelForm', () => import('./AxE2ModelForm'))
Vue.component('AxE2ModelDisplay', () => import('./AxE2ModelDisplay'))
Vue.component('AppHookableComopnent', () => import('@shared/nuxt/components/AppHookableComponent'))

// additionals
// Loading状態を表示する <b-skeleton/> https://bootstrap-vue.org/docs/components/skeleton#skeleton
Vue.component(
  'BSkeleton',
  () => import('../../../CORE_FW/firebase_nuxt/node_modules/bootstrap-vue/esm/components/skeleton')
)

// star-rating
Vue.component('star-rating', StarRating)
